import React from 'react';
import { Reveal } from './Reveal';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

export const IndustryPresence: React.FC = () => {
  const { industry } = useContent();

  return (
    <section id="industry">
      <div className="section-head">
        <div>
          <div className="eyebrow">{industry.eyebrow}</div>
          <h2
            className="display-h2"
            style={{ marginTop: 14 }}
            dangerouslySetInnerHTML={{ __html: industry.headingHtml }}
          />
        </div>
      </div>

      <div className="industry-wrap">
        {industry.cards.map((c, i) => (
          <Reveal key={c.t} delay={i * 60} className={`industry-card glass-soft ${c.span ?? ''}`.trim()}>
            <div className="ic-icon">{c.tag}</div>
            <h4>{c.t}</h4>
            <p>{c.d}</p>
          </Reveal>
        ))}
      </div>

      <div className="section-head" style={{ marginTop: 80 }}>
        <div>
          <div className="eyebrow">{industry.mentoringEyebrow}</div>
          <h2
            className="display-h2"
            style={{ marginTop: 14 }}
            dangerouslySetInnerHTML={{ __html: industry.mentoringHeadingHtml }}
          />
        </div>
      </div>

      <div className="industry-wrap">
        {industry.mentoring.map((c, i) => (
          <Reveal key={c.t} delay={i * 80} className="industry-card glass span-2">
            <div className="ic-icon">{c.tag}</div>
            <h4>{c.t}</h4>
            <p>{c.d}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
